import * as React from 'react';
import styled from 'styled-components';
import { horizontalSpace, verticalSpace } from '@doltech/utils/lib/css-style';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';

const Container = styled.div`
  width: 100%;
  display: flex;
  ${horizontalSpace(12)};
`;

const Info = styled.div`
  ${verticalSpace(4)};
`;

interface TimerDoTestGrammarProps {
  time?: string;
  lastAccess?: string;
}

export const TimerDoTestGrammar = (props: TimerDoTestGrammarProps) => {
  const { time, lastAccess } = props;

  return (
    <Container>
      <Info>
        <ResponsiveTypography.Paragraph variant="regular/16-24" color="gray120">
          Time:
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph variant="semi-bold/16-24" color="gray180">
          {time ? time : '0'}
        </ResponsiveTypography.Paragraph>
      </Info>
      <Info>
        <ResponsiveTypography.Paragraph variant="regular/16-24" color="gray120">
          Last access:
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph variant="semi-bold/16-24" color="gray180">
          {lastAccess ? lastAccess : '-'}
        </ResponsiveTypography.Paragraph>
      </Info>
    </Container>
  );
};
